const deepMerge = <T>(a: T, b: T) => {
    const result = { ...a };
    for (const key in b) {
        const value = b[key];
        if (value !== null && typeof value === 'object') {
            result[key] = deepMerge(result[key], value);
        } else {
            result[key] = value;
        }
    }
    return result;
};

export default deepMerge;
